import React from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Form from 'components/Form';
import Select from 'components/Select';
import conditionValues, {CONDITION_TYPE_OTHER, CONDITIONS_LABEL, CONDITIONS_LABEL_PZP_2021, conditionValues_PZP_2021} from './constants/condition.values';
import Tr from 'translations/Translations';
import TextInput from 'components/TextInput';
import PartsTable from 'components/PartsTable';
import validationSchema from './constants/validation.form'
import ImputLimits from 'constants/InputLimits';
import {getDemandPZPType, isDemandPreparing} from "libs/getDemandStatus";
import PZPType from "constants/PZPType";

const limits = ImputLimits.procedure.condition;

const style = theme => ({
	root: {
	},
	uploadFile: {
		marginBottom: theme.spacing(2)
	}
})

function ConditionForm({
	classes,
	onSubmit = () => { },
	id,
	partId,
	initValues,
	elementList,
	selectedItems,
	editable,
}) {

	const demandPzpType = getDemandPZPType();
	const conditionLabels = PZPType.PZP_2021 === demandPzpType ? CONDITIONS_LABEL_PZP_2021 : CONDITIONS_LABEL;
	const conditionValuesDict = PZPType.PZP_2021 === demandPzpType ? conditionValues_PZP_2021 : conditionValues;

	const getInitialValues = (typeElements) => {
		if (initValues !== undefined) {
			return {
				...initValues,
				parts: {
					[partId]: true,
				},
			};
		}
		return {
			type: typeElements[0].value,
			description: '',
			parts: {
				[partId]: true,
			},
			otherName: '',
			file: null,
		}
	}

	const getNames = () => {
		let selected = selectedItems.map(x => {
			if (x.type === CONDITION_TYPE_OTHER) return x.otherName;
			return conditionLabels[x.type];
		})
		if (initValues !== undefined) {
			let initValuesName = conditionLabels[initValues.type];
			if (initValues.type === CONDITION_TYPE_OTHER) {
				initValuesName = initValues.otherName;
			}
			var index = selected.indexOf(initValuesName);
			if (index > -1) {
				selected.splice(index, 1);
			}
		}
		return selected;
	}


	const typeElements = conditionValuesDict.reduce((acc, item) => {
		if (item.value === CONDITION_TYPE_OTHER) return [...acc, item];
		if (initValues !== undefined) {
			if (item.value === initValues.type) {
				return [...acc, item]
			}
		}
		if (selectedItems.find(x => x.type === item.value)) {
			return acc;
		}
		return [...acc, item]
	}, [])

	return (
		<Form
			id={id}
			onSubmit={onSubmit}
			initialValues={{
				...getInitialValues(typeElements),
				_editable: editable,
			}}
			validationSchema={validationSchema(getNames())}
		>
			{(formikProps) => (
				<>
					<Select
						id={'type'}
						formikProps={formikProps}
						items={typeElements}
						label={Tr('condition')}
						disabled={!isDemandPreparing() && !!initValues}
					/>
					{formikProps.values.type === CONDITION_TYPE_OTHER &&
						<TextInput
							id='otherName'
							formikProps={formikProps}
							label={Tr('condition_name')}
							limit={limits.OTHER_NAME}
							required
							disabled={!isDemandPreparing() && !!initValues}
						/>
					}
					<TextInput
						id={'description'}
						formikProps={formikProps}
						label={Tr('condition_description')}
						multiline
					/>

					{/*<Box component="div" className={classes.uploadFile}>
						<UploadFile
							id="attachments"
							formikProps={formikProps}
							label={Tr("attachment")}
						/>
					</Box>*/}
					{elementList.length > 1 &&
						<PartsTable
							id={'parts'}
							formikProps={formikProps}
							elementList={elementList}
						/>
					}
				</>
			)}
		</Form>
	)
}

ConditionForm.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(ConditionForm);